/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_TitleInputs */

const en_guide_json_rest_api_title = /** @type {(inputs: Guide_Json_Rest_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to Use JSON in REST APIs: PureJSON`)
};

const ko_guide_json_rest_api_title = /** @type {(inputs: Guide_Json_Rest_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST API에서 JSON 사용법: PureJSON`)
};

const ja_guide_json_rest_api_title = /** @type {(inputs: Guide_Json_Rest_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST APIでJSONを使用する方法: PureJSON`)
};

/**
* | output |
* | --- |
* | "How to Use JSON in REST APIs: PureJSON" |
*
* @param {Guide_Json_Rest_Api_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_title = /** @type {((inputs?: Guide_Json_Rest_Api_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_title(inputs)
	return ja_guide_json_rest_api_title(inputs)
});